<script>
  import Button from "lib/components/buttonIconOnly.svelte";
  export let small = false;
  export let handleEdit = () => {};
  export let handleDelete = () => {};
  export let handleZoomIn = () => {};
  export let handleRestart = () => {};
  export let handleExpandable = () => {};
  export let disabled = false;
  export let restart = false;
  export let expandable = false;
  export let details = false;
</script>

<div
  style="display: flex; gap: 4px; margin: 8px; justify-content: center; align-items: center;"
  class:disabled={disabled && !restart}
>
  {#if expandable && !restart}
    <Button {small} icon="edit" on:click={handleEdit} disable={disabled} />
    <Button {small} icon="trash" on:click={handleDelete} disable={disabled} />
    <Button {small} icon="chevron_down" on:click={handleExpandable} />
  {:else if restart}
    <Button {small} icon="reset_alt" on:click={handleRestart} />
  {:else}
    {#if details}
      <Button
        {small}
        icon="zoomin"
        on:click={handleZoomIn}
        disable={disabled}
      />
    {/if}
    <Button {small} icon="edit" on:click={handleEdit} disable={disabled} />
    <Button {small} icon="trash" on:click={handleDelete} disable={disabled} />
  {/if}
</div>

<style>
  .disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .disabled:hover {
    pointer-events: none;
  }
</style>
